import EditProfile from "../PureComponents/EditProfile";
import React from "react";

const RenderEditProfile = ({ currEle, popup, hide  , getAllCategories,  getAllLocations,
  getcategory, reactivateTrashUser,

         categoryexist,
         locationexist}) => {
  return (
    <>
      <EditProfile currEle={currEle} popup={popup} hide={hide}   getAllCategories={  getAllCategories} getAllLocations={getAllLocations} getcategory={getcategory} reactivateTrashUser={reactivateTrashUser}

         categoryexist={categoryexist}
         locationexist={locationexist} />
    </>
  );
};

export default RenderEditProfile;
